import * as auth from './auth.js'
import * as user from './user.js'
import * as file from './file.js'
import * as pay from './pay.js'

// 聚合各业务模块的接口，保持统一的 Request 调用入口
const Request = {
  ...auth,
  ...user,
  ...file,
  ...pay,
}

export { Request }
